import { Module } from 'wrapper6'
import Glide from '@glidejs/glide'
import { ArrowControls } from '../utils/_glide-plugins'

const $ = jQuery

export default class CoverSlider extends Module {
  ready (app) {
    this.CoverGlides = document.querySelectorAll('.mtt-cover .glide')

    if (this.CoverGlides.length) {
      for (let i = 0; i < this.CoverGlides.length; i++) {
        const CoverGlide = this.CoverGlides[i]

        new Slider(CoverGlide)
      }
    }
  }
}

class Slider {
  constructor (glide) {
    this.glide = glide

    this.addSlider()
  }

  addSlider () {
    const glideCount = this.glide.querySelectorAll('.glide__slide').length
    if (glideCount > 1) {
      new Glide(this.glide, {
        type: 'carousel',
        autoplay: 5000,
        animationDuration: 2500,
        hoverpause: false,
        gap: 0,
        arrowClasses: {
          back: 'cover-arrow-left',
          next: 'cover-arrow-right'
        }
      }).mount({ ArrowControls })
    } else {
      this.glide.classList.add('disabled')
    }
  }
}
